import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { termAndConditionsApi, TermAndConditionsPayload } from '@/api/termAndConditions';
import { useActionFeedback } from '@/hooks/useActionFeedback';

export const useTermAndConditions = (enabled = true) =>
  useQuery({
    queryKey: ['privacy-policy'],
    queryFn: () => termAndConditionsApi.get(),
    enabled,
  });

export const useCreateTermAndConditions = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: (data: TermAndConditionsPayload) => termAndConditionsApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['privacy-policy'] });
      feedback.success('Term and Conditions berhasil dibuat');
    },
    onError: (error) => {
      feedback.error('Gagal membuat term and conditions', error);
    },
  });
};

export const useUpdateTermAndConditions = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: (data: TermAndConditionsPayload) => termAndConditionsApi.update(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['privacy-policy'] });
      feedback.success('Term and Conditions berhasil diperbarui');
    },
    onError: (error) => {
      feedback.error('Gagal memperbarui term and conditions', error);
    },
  });
};

export const useDeleteTermAndConditions = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: () => termAndConditionsApi.delete(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['privacy-policy'] });
      feedback.success('Term and Conditions berhasil dihapus');
    },
    onError: (error) => {
      feedback.error('Gagal menghapus term and conditions', error);
    },
  });
};